/* esm.sh - mdast-util-gfm-footnote@2.1.0 */
export * from "/*mdast-util-gfm-footnote@2.1.0/esnext/mdast-util-gfm-footnote.mjs";
